export function partnerRegistryKey(key) {
  if (!key || typeof key !== 'string') return null;
  return key.toLowerCase();
}

export function parsePartnerRegistry(raw) {
  if (!raw) return {};
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw) || {};
    } catch (e) {
      return {};
    }
  }
  return raw;
}

function pick(obj, ...keys) {
  if (!obj) return undefined;
  for (const k of keys) {
    if (obj[k] != null) return obj[k];
  }
  return undefined;
}

function normalizeProgram(program) {
  if (!program) return null;
  const enrollmentRaw = pick(program, 'enrollment_status', 'enrollmentStatus');
  let enrollmentStatus = null;
  if (enrollmentRaw && typeof enrollmentRaw === 'object') {
    enrollmentStatus = {
      url: pick(enrollmentRaw, 'url'),
      label: pick(enrollmentRaw, 'label')
    };
  }
  return {
    programName: pick(program, 'program_name', 'programName'),
    categoryLabel: pick(program, 'category_label', 'categoryLabel'),
    description: pick(program, 'description'),
    descriptionLong: pick(program, 'description_long', 'descriptionLong'),
    participationDescription: pick(
      program,
      'participation_description',
      'participationDescription'
    ),
    actionList: pick(program, 'action_list', 'actionList') || [],
    enrollmentStatus,
    enrollmentStatusUrl:
      pick(program, 'enrollment_status_url', 'enrollmentStatusUrl') ||
      enrollmentStatus?.url ||
      null,
    logoUrl: pick(program, 'logo_url', 'logoUrl', 'logo')
  };
}

export function getScanDataProgram(partnerRegistry, key) {
  const registry = parsePartnerRegistry(partnerRegistry);
  const lowerKey = partnerRegistryKey(key);
  if (!lowerKey) return null;
  const entry = registry[lowerKey] || registry[key];
  if (!entry) return null;
  const program = entry.scan_data_program || entry.scanDataProgram;
  return normalizeProgram(program);
}
